// extracted by mini-css-extract-plugin
export default {"tooltipHolder":"styles_tooltipHolder__-jNH2"};